import { render } from "./inputPhone.vue?vue&type=template&id=959f632c"
import script from "./inputPhone.vue?vue&type=script&lang=js"
export * from "./inputPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__